module.exports = __webpack_public_path__ + "img/icon_scroll.0cb4da2b.svg";